<template>
  <div class="row">
    <div class="col-xl-12">
      <router-view />

      <div
        v-show="$route.path == '/Report/KegRotationScore'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-chart-bar"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
              <a href="#" class="ml-2" style="font-size: 0.8em; font-weight: normal;" @click.prevent="showCriteriaModal">
                <i class="fa fa-info-circle"></i> เงื่อนไขการคำนวณคะแนน
              </a>
            </h3>
          </div>
        </div>

        <!-- begin: Criteria Modal -->
        <div class="modal fade" id="criteriaModal" tabindex="-1" role="dialog" aria-labelledby="criteriaModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="criteriaModalLabel">เงื่อนไขการคำนวณคะแนนรายงานนี้</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="criteria-section">
                  <p class="mb-2"><strong>ประเภทสินค้า : ถัง/ท่อ</strong></p>
                  <div class="criteria-headers mb-3">
                    <span class="col-label">เงื่อนไข</span>
                    <span class="col-label">เกณฑ์การให้คะแนน</span>
                  </div>

                  <p class="product-title"><strong>ถังเบียร์สด</strong></p>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <p class="season-title high">High Season</p>
                      <div class="criteria-box">
                        <div class="criteria-row"><span>&lt;=3 Months</span><span>1 - 90 วัน</span><span>40 คะแนน</span></div>
                        <div class="criteria-row"><span>3-4 Months</span><span>91-120 วัน</span><span>20 คะแนน</span></div>
                        <div class="criteria-row"><span>4 Months</span><span>121 วัน ขึ้นไป</span><span>10 คะแนน</span></div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <p class="season-title low">Low Season</p>
                      <div class="criteria-box">
                        <div class="criteria-row"><span>&lt;=5 Months</span><span>1 - 150 วัน</span><span>40 คะแนน</span></div>
                        <div class="criteria-row"><span>5-6 Months</span><span>151-180 วัน</span><span>20 คะแนน</span></div>
                        <div class="criteria-row"><span>6 Months</span><span>181 วัน ขึ้นไป</span><span>10 คะแนน</span></div>
                      </div>
                    </div>
                  </div>

                  <p class="product-title"><strong>ท่อ CO2</strong></p>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <p class="season-title high">High Season</p>
                      <div class="criteria-box">
                        <div class="criteria-row"><span>&lt;=5 Months</span><span>1 - 150 วัน</span><span>40 คะแนน</span></div>
                        <div class="criteria-row"><span>5-6 Months</span><span>151-180 วัน</span><span>20 คะแนน</span></div>
                        <div class="criteria-row"><span>6 Months</span><span>181 วัน ขึ้นไป</span><span>10 คะแนน</span></div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <p class="season-title low">Low Season</p>
                      <div class="criteria-box">
                        <div class="criteria-row"><span>&lt;=5 Months</span><span>1 - 150 วัน</span><span>40 คะแนน</span></div>
                        <div class="criteria-row"><span>5-6 Months</span><span>151-180 วัน</span><span>20 คะแนน</span></div>
                        <div class="criteria-row"><span>6 Months</span><span>181 วัน ขึ้นไป</span><span>10 คะแนน</span></div>
                      </div>
                    </div>
                  </div>

                  <p class="mb-2">
                    ช่วง <strong style="color:rgb(10, 187, 135)">High Season</strong> มีจำนวน 6 เดือน [ เดือน ม.ค. , ก.พ. , มี.ค. , ต.ค. , พ.ย. , ธ.ค. ]
                    <u>ถังเบียร์สดทุกสินค้า คงค้างไม่เกิน 3 เดือน [ 90 วัน ]</u>
                  </p>
                  <p class="mb-3">
                    ช่วง <strong style="color:#C00000">LOW Season</strong> มีจำนวน 6 เดือน [ เดือน เม.ย. , พ.ค. , มิ.ย. , ก.ค. , ส.ค. , ก.ย. ] ถัง / ท่อ เบียร์สดทุกสินค้า คงค้างไม่เกิน 5 เดือน [ 150 วัน ]
                  </p>

                  <p class="mb-1"><strong>หมายเหตุสำคัญ :</strong></p>
                  <ul class="mb-0" style="padding-left: 20px;">
                    <li>วันคงค้าง เริ่มนับวัน ตั้งแต่วันที่รับสินค้าจากโรงงาน (วันที่รับ = วันที่ 0 วัน)</li>
                    <li>สินค้าประเภทท่อเบียร์สด ช่วง <strong>High Season</strong> และ <strong>LOW Season</strong> คงค้างไม่เกิน 5 เดือน [ 150 วัน ] เท่ากัน จำนวนที่แสดงในรายงานจะรวมมาแสดงเฉพาะที่ช่วงคงค้าง Low Season เท่านั้นไม่ไปแสดงที่คอลัมน์ ช่วง <strong>High Season</strong> เพื่อไม่เกิดความสับสนในการดูข้อมูล</li>
                    <li>คะแนนระหว่างเดือนปัจจุบันจะแสดงค่าว่าง คะแนนจะแสดงต่อเมื่อคำนวณ Auto ณ วันที่สิ้นเดือนแล้วผ่านระบบ</li>
                  </ul>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">ปิด</button>
              </div>
            </div>
          </div>
        </div>
        <!-- end: Criteria Modal -->

        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <!-- Row 1 -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="mb-1">เดือน/ปี:</label>
                  <input
                    type="text"
                    class="form-control"
                    ref="monthYearPicker"
                    placeholder="เลือกเดือน/ปี"
                    readonly
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="mb-1">ประเภทสินค้า:</label>
                  <treeselect
                    v-model="productType"
                    :multiple="true"
                    :options="productTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="mb-1">สถานะ:</label>
                  <treeselect
                    v-model="barcodeStatusCode"
                    :multiple="true"
                    :options="barcodeStatusCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <!-- Row 2 -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="mb-1">ชื่อตัวแทนจำหน่าย:</label>
                  <treeselect
                    v-model="agentCode"
                    :multiple="true"
                    :options="agentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="mb-1">ชื่อสินค้า:</label>
                  <treeselect
                    v-model="materialCode"
                    :multiple="true"
                    :options="materialCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="mb-1">ช่วงคงค้าง:</label>
                  <treeselect
                    v-model="retentionPeriod"
                    :multiple="true"
                    :options="retentionPeriodOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <!-- Row 3 -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="mb-1">ชื่อตัวแทนจำหน่าย(Group):</label>
                  <treeselect
                    v-model="headAgentCode"
                    :multiple="true"
                    :options="headAgentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="mb-1">ชื่อแบรนด์สินค้า:</label>
                  <treeselect
                    id="ProductIdBrand"
                    v-model="productBrand"
                    :multiple="true"
                    :options="filteredProductBrandOptions"
                    placeholder="กรุณาเลือก"
                    ref="ProductIdBrand"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="mb-1">คะแนน:</label>
                  <treeselect
                    v-model="score"
                    :multiple="true"
                    :options="scoreOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <!-- Row 4 -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="mb-1">ประเภทผู้ถือครอง:</label>
                  <treeselect
                    v-model="ownerType"
                    :multiple="true"
                    :options="ownerTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="mb-1">แบรนด์สินค้า:</label>
                  <treeselect
                    v-model="brand"
                    :multiple="true"
                    :options="brandOptions"
                    v-on:select="BrandIdClearAfterSelect"
                    v-on:deselect="BrandIdClearAfterDeSelect"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                  <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button type="reset" class="btn btn-secondary" @click="formReset">
                  ล้างค่าทั้งหมด
                </button>
              </div>
 

              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary mr-2"
                  @click="exportCompareReport"
                  type="button"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel (สำหรับตรวจสอบข้อมูล)</span>
                  </span>
                </button>
                <button
                  class="btn btn-outline-primary"
                  @click="exportMachineScore"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel (สรุปข้อมูลจากรายงาน)</span>
                  </span>
                </button>
              </div>
            </div>
            <!-- Buttons -->
             
          </form>
          <!-- end: Search Form -->

          <!-- begin: Result Table -->
          <div class="row mt-0">

            <div class="col-xl-12">
              <!-- Top scrollbar -->
              <div ref="topScrollWrapper" style="overflow-x:auto; overflow-y:hidden; height:20px;">
                <div ref="topScrollContent" style="height:1px;"></div>
              </div>
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                ref="kegRotationTable"
                style="width: 100%"
              >
                <thead>
                   <tr  v-if="dataAsOfLabel">
                    <th class="all text-right" colspan="16">
                      <span>{{ dataAsOfLabel }}</span>
                    </th>
                  </tr> 
                  <tr>
                    <th rowspan="2">รหัสตัวแทนจำหน่าย</th>
                    <th rowspan="2">ชื่อตัวแทนจำหน่าย</th>
                    <th rowspan="2">รหัสสินค้า</th>
                    <th rowspan="2">ชื่อสินค้า</th>
                    <th colspan="3" class="text-center" style="font-size: 0.9em !important;background-color: #808080 !important;color:#ffffff !important;">ช่วงคงค้าง High Season</th>
                    <th rowspan="2" class="text-center" style="font-size: 0.9em !important;">Total</th>
                    <th rowspan="2" class="text-center" style="font-size: 0.9em !important;">คะแนน</th>
                    <th colspan="3" class="text-center" style="font-size: 0.9em !important;background-color: #808080 !important;color:#63C8FF !important;">ช่วงคงค้าง Low Season</th>
                    <th rowspan="2" class="text-center" style="font-size: 0.9em !important;">Total</th>
                    <th rowspan="2" class="text-center" style="font-size: 0.9em !important;">คะแนน</th>
                    <th rowspan="2" class="text-center" style="font-size: 0.9em !important;">Total จำนวน</th>
                    <th rowspan="2" class="text-center" style="font-size: 0.9em !important;color:#0033CC !important;">สรุปผลคะแนน<br/>ประจำเดือน</th>
                  </tr>
                  <tr>
                    <th class="text-center" style="font-size: 0.9em !important;background-color: #ABE7B2 !important; color: rgb(10, 187, 135) !important;">ไม่เกิน 3 เดือน</th>
                    <th class="text-center" style="font-size: 0.9em !important;background-color: #FFFBB1 !important;">ไม่เกิน 4 เดือน</th>
                    <th class="text-center" style="font-size: 0.9em !important;background-color: #F8CBAD !important; color: #C00000 !important;">เกิน 4 เดือน</th>
                    <th class="text-center" style="font-size: 0.9em !important;background-color: #ABE7B2 !important; color: rgb(10, 187, 135) !important; ">ไม่เกิน 5 เดือน</th>
                    <th class="text-center" style="font-size: 0.9em !important;background-color: #FFFBB1 !important; ">ไม่เกิน 6 เดือน</th>
                    <th class="text-center" style="font-size: 0.9em !important;background-color: #F8CBAD !important; color: #C00000 !important;">เกิน 6 เดือน</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th colspan="4" style="text-align:center">Grand Total</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!-- end: Result Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.group-header {
  background-color: #ddd !important;
  font-weight: bold;
}
.group-header td.td-header {
  background-color: #f4f4f4 !important;
  font-weight: bold;
}
.group-footer-sub td.td-footer {
  background-color: #f1efef !important;
  font-weight: bold;
  padding-left: 0 !important;
}
.bg-red {
  background-color: #FCE4D6 !important;
   color: #C00000 !important;
}
.bg-green {
  background-color: #CCFFCC !important;
  color: rgb(10, 187, 135) !important;
}
.bg-yellow{
  background-color: #FFFDE1 !important;
}

/* Criteria Modal */
.criteria-section .col-label {
  display: inline-block;
  font-weight: bold;
  margin-right: 2rem;
}
.criteria-section .product-title {
  margin-top: 0.5rem;
  margin-bottom: 0.25rem;
}
.criteria-section .season-title {
  font-weight: bold;
  margin-bottom: 0.25rem;
}
.criteria-section .season-title.high { color: rgb(10, 187, 135); }
.criteria-section .season-title.low  { color: #C00000; }
.criteria-section .criteria-box {
  background: #0f2544;
  color: #fff;
  padding: 10px 14px;
  border-radius: 4px;
}
.criteria-section .criteria-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  padding: 3px 0;
}
.criteria-section .criteria-row:nth-child(1) span { color: #7FE0FF; }
.criteria-section .criteria-row:nth-child(2) span,
.criteria-section .criteria-row:nth-child(3) span { color: #FF6B6B; }
</style>

<script>
import axios from "axios";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    Treeselect,
  },
  data: function () {
    return {
      // DataTable instance
      dataTable: null,

      // Month/Year filter
      monthYear: null,

      // label แสดง "ข้อมูล ณ ..."
      dataAsOfLabel: '',

      // Filter values
      productType: [],
      barcodeStatusCode: [],
      agentCode: [],
      materialCode: [],
      retentionPeriod: [],
      headAgentCode: [],
      productBrand: [],
      score: [],
      ownerType: [],
      brand: [],

      // Filter options
      productTypeOptions: [],
      barcodeStatusCodeOptions: [],
      agentCodeOptions: [],
      materialCodeOptions: [],
      retentionPeriodOptions: [
        { id: "ไม่เกิน 3 เดือน", label: "ไม่เกิน 3 เดือน" },
        { id: "ไม่เกิน 4 เดือน", label: "ไม่เกิน 4 เดือน" },
        { id: "เกิน 4 เดือน", label: "เกิน 4 เดือน" },
        { id: "เกิน 5 เดือน", label: "เกิน 5 เดือน" },
      ],
      headAgentCodeOptions: [],
      productBrandOptions: [],
      fullProductData: [],
      scoreOptions: [
        { id: 10, label: "10" },
        { id: 20, label: "20" },
        { id: 40, label: "40" },
      ],
      ownerTypeOptions: [],
      brandOptions: [],
    };
  },
  mounted: function () {
    this.initMonthYearPicker();
    this.loadProductTypeOptions();
    this.loadBarcodeStatusCodeOptions();
    this.loadAgentCodeOptions();
    this.loadMaterialCodeOptions();
    this.loadHeadAgentCodeOptions();
    this.loadProductBrandOptions();
    this.loadOwnerTypeOptions();
    this.loadBrandOptions();
    this.initDataTable();
  },
  computed: {
    filteredProductBrandOptions: function () {
      if (!this.brand.length) {
        return this.productBrandOptions;
      }
      var selectedBrandIds = this.brand.map(Number);
      var filteredOptions = [];
      this.fullProductData.forEach(function (item) {
        if (selectedBrandIds.indexOf(item.data.productBrandId) !== -1) {
          filteredOptions.push({
            id: item.id,
            label: item.text,
            productBrandId: item.data.productBrandId,
          });
        }
      });
      return filteredOptions;
    },
  },
  methods: {
    showCriteriaModal: function () {
      $("#criteriaModal").modal("show");
    },
    initMonthYearPicker: function () {
      var self = this;
      var arrows;
      if (KTUtil.isRTL()) {
        arrows = {
          leftArrow: '<i class="la la-angle-right"></i>',
          rightArrow: '<i class="la la-angle-left"></i>',
        };
      } else {
        arrows = {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        };
      }

      // Default = current month/year
      self.monthYear = moment();

      $(self.$refs.monthYearPicker).datepicker({
        format: "mm/yyyy",
        viewMode: "months",
        minViewMode: "months",
        autoclose: true,
        clearBtn: true,
        rtl: KTUtil.isRTL(),
        orientation: "bottom left",
        templates: arrows,
      });
      $(self.$refs.monthYearPicker)
        .datepicker("update", self.monthYear.format("MM/YYYY"))
        .on("changeDate", function (e) {
          self.monthYear = e.dates.length !== 0 ? moment(e.date) : null;
        });
    },

    // ประเภทสินค้า
    loadProductTypeOptions: function () {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: { page: 1, all: true },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              if (element.id == 4 || element.id == 5) {
                self.productTypeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              }
            });
          }
        })
        .catch(function (error) {});
    },

    // สถานะ
    loadBarcodeStatusCodeOptions: function () {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", {
          params: { page: 1, all: true },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.barcodeStatusCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) {});
    },

    // ชื่อตัวแทนจำหน่าย
    loadAgentCodeOptions: function () {
      var self = this;
      axios
        .post("/Api/Report/Select2Agent", {
          province_id: [],
          department: [],
          AgentCodes: [],
          page: 1,
          all: true,
          IsShowInAgentScoreReport: true,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.agentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) {});
    },

    // ชื่อสินค้า
    loadMaterialCodeOptions: function () {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: { page: 1, all: true, excludeProductGroupId: 14 },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.materialCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) {});
    },

    // เคลียร์ ชื่อแบรนด์สินค้า เมื่อเลือก/ยกเลิก แบรนด์สินค้า
    BrandIdClearAfterSelect: function () {
      this.productBrand = [];
    },
    BrandIdClearAfterDeSelect: function () {
      this.productBrand = [];
    },

    // ชื่อตัวแทนจำหน่าย(Group)
    loadHeadAgentCodeOptions: function () {
      var self = this;
      axios
        .post(
          "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
          {
            province_id: [],
            department: [],
            AgentCodes: [],
            page: 1,
            IsShowInAgentScoreReport: true,
            IsHead: true,
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.headAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) {});
    },

    // ชื่อแบรนด์สินค้า — โหลดข้อมูลทั้งหมดพร้อม productBrandId เพื่อใช้ filter ตามแบรนด์
    loadProductBrandOptions: function () {
      var self = this;
      axios
        .post("/Api/product/Select2ProductReport", {
          page: 1,
          all: true,
          search: "",
          productGroupIds: [14],
        })
        .then(function (response) {
          if (response.status === 200) {
            self.fullProductData = response.data.results;
            self.productBrandOptions = self.fullProductData.map(function (item) {
              return {
                id: item.id,
                label: item.text,
                productBrandId: item.data.productBrandId,
              };
            });
          }
        })
        .catch(function (error) {
          console.error("Error loading product data:", error);
        });
    },

    // ประเภทผู้ถือครอง — ใช้ hardcoded เหมือน Barcodes (SP รับ Thai text)
    loadOwnerTypeOptions: function () {
      var self = this;
      var data = [
        { id: "ตัวแทนจำหน่าย",          label: "ตัวแทนจำหน่าย" },
        { id: "ตัวแทนจำหน่ายย่อย",      label: "ตัวแทนจำหน่ายย่อย" },
        { id: "ร้านค้า",                label: "ร้านค้า" },
        { id: "ร้านค้า (ตัวแทนฯย่อย)", label: "ร้านค้า (ตัวแทนฯย่อย)" },
      ];
      self.ownerTypeOptions = data;
    },

    // แบรนด์
    loadBrandOptions: function () {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: { page: 1, all: true },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.brandOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) {});
    },

    formSubmit: function (e) {
      e.preventDefault();
      this.dataTable.ajax.reload();
    },

    initDataTable: function () {
      var self = this;

      // map ช่วงคงค้าง option → day range สำหรับ @OverDueFrom / @OverDueTo
      function calcRetentionRange(selected) {
        if (!selected || selected.length === 0) return { from: null, to: null };
        var rangeMap = {
          "ไม่เกิน 3 เดือน": { from: 1,   to: 90  },
          "ไม่เกิน 4 เดือน": { from: 91,  to: 120 },
          "เกิน 4 เดือน":    { from: 121, to: null },
          "เกิน 5 เดือน":    { from: 151, to: null },
        };
        var froms = [], tos = [], hasOpenEnd = false;
        selected.forEach(function(r) {
          var rng = rangeMap[r];
          if (!rng) return;
          froms.push(rng.from);
          if (rng.to !== null) { tos.push(rng.to); } else { hasOpenEnd = true; }
        });
        return {
          from: froms.length ? Math.min.apply(null, froms) : null,
          to:   hasOpenEnd ? null : (tos.length ? Math.max.apply(null, tos) : null),
        };
      }

      function formatNumber(val) {
        if (val === null || val === undefined || val === 0) return "-";
        return val.toLocaleString();
      }

      function renderScore(val) {
        if (val === null || val === undefined || val === 0) return "-";
        if (val >= 40) return '<span>' + val + "</span>";
        if (val >= 20) return '<span>' + val + "</span>";
        return '<span>' + val + "</span>";
      }

      self.dataTable = $(self.$refs.kegRotationTable).DataTable({
        scrollX: true,
        responsive: false,
        processing: true,
        serverSide: true,
        deferLoading: 0,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/SearchMachineScore",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function (d) {
            var retentionRange = calcRetentionRange(self.retentionPeriod);
            var jsonSearch = {
              IsInitial: false,
              AgentCodes: self.agentCode,
              HeadAgentCodes: self.headAgentCode,
              AssetCodes: self.materialCode,
              ProductTypeIds: self.productType,
              BarcodeStatusCodes: self.barcodeStatusCode,
              FinishedProductCodes: self.productBrand,
              BrandIds: self.brand,
              CurrentLocationType: self.ownerType,
              OverDueFrom: retentionRange.from,
              OverDueTo: retentionRange.to,
              FinalScore: self.score.length === 1 ? self.score[0] : 0,
              Month: self.monthYear ? self.monthYear.month() + 1 : null,
              Year: self.monthYear ? self.monthYear.year() : null,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        drawCallback: function () {
          this.api().columns.adjust();
          var thaiMonths = ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน',
                            'กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม'];
          var now = moment();
          var isCurrentMonth = !self.monthYear
            || (self.monthYear.year() === now.year() && self.monthYear.month() === now.month());
          if (isCurrentMonth) {
            self.dataAsOfLabel = 'ข้อมูล ณ วันที่ ' + now.format('DD/MM/YYYY h:mm a');
          } else {
            self.dataAsOfLabel = 'ข้อมูล ณ เดือน ' + thaiMonths[self.monthYear.month()] + ' ' + self.monthYear.year();
          }
        },
        dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
        lengthMenu: [50, 100, 200, 500],
        pageLength: 50,
        language: {
          lengthMenu: "Display _MENU_",
        },
        order: [[0, "asc"]],
        columns: [
          { data: "agentCode", className: "text-center", orderable: true },
          { data: "agentName", className: "text-left", orderable: true },
          { data: "assetCode", className: "text-center", orderable: false },
          { data: "assetName", className: "text-left", orderable: false },
          // High Season
          { data: "high_3Month", className: "text-center bg-green", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "high_3_4Month", className: "text-center bg-yellow", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "high_Over4Month", className: "text-center bg-red", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "high_Total", className: "text-center", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "high_Score", className: "text-center", orderable: false, render: function (data, type) { return type === "display" ? renderScore(data) : data; } },
          // Low Season
          { data: "low_5Month", className: "text-center bg-green", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "low_5_6Month", className: "text-center bg-yellow", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "low_Over6Month", className: "text-center bg-red", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "low_Total", className: "text-center", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "low_Score", className: "text-center", orderable: false, render: function (data, type) { return type === "display" ? renderScore(data) : data; } },
          // Summary
          { data: "total", className: "text-center", orderable: false, render: function (data) { return formatNumber(data); } },
          // Summary
          { data: "finalScore", className: "text-center", orderable: false, render: function (data) { return ''; } },
        ],
        rowGroup: {
          dataSrc: "agentCode",
          startRender: function (rows, group) {
            var agentName = rows.data()[0].agentName || group;
            return $('<tr class="group-header"/>').append(
              '<td colspan="16" class="td-header">' + agentName + "</td>"
            );
          },
          endRender: function (rows, group) {
            var agentName = rows.data()[0].agentName || group;
            var totH3 = rows.data().pluck("high_3Month").reduce(function (a, b) { return a + Number(b); }, 0);
            var totH34 = rows.data().pluck("high_3_4Month").reduce(function (a, b) { return a + Number(b); }, 0);
            var totHO4 = rows.data().pluck("high_Over4Month").reduce(function (a, b) { return a + Number(b); }, 0);
            var totHT = rows.data().pluck("high_Total").reduce(function (a, b) { return a + Number(b); }, 0);
            var hsArr = rows.data().pluck("high_Score").toArray().filter(x => Number(x) !== 0);
            var totHS = hsArr.length ? Math.min.apply(null, hsArr) : 0;
            var totL5 = rows.data().pluck("low_5Month").reduce(function (a, b) { return a + Number(b); }, 0);
            var totL56 = rows.data().pluck("low_5_6Month").reduce(function (a, b) { return a + Number(b); }, 0);
            var totLO6 = rows.data().pluck("low_Over6Month").reduce(function (a, b) { return a + Number(b); }, 0);
            var totLT = rows.data().pluck("low_Total").reduce(function (a, b) { return a + Number(b); }, 0);
            var lsArr = rows.data().pluck("low_Score").toArray().filter(x => Number(x) !== 0);
            var totLS = lsArr.length ? Math.min.apply(null, lsArr) : 0;
            var totTotal = rows.data().pluck("total").reduce(function (a, b) { return a + Number(b); }, 0);
            var fsArr = rows.data().pluck("finalScore").toArray().filter(x => Number(x) !== 0);
            var finalScore = fsArr.length ? Math.min.apply(null, fsArr) : 0;

            return $('<tr class="group-footer-sub"/>')
              .append('<td class="td-footer" colspan="4" style="max-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">Total ' + agentName + "</td>")
              .append('<td class="td-footer text-center">' + formatNumber(totH3) + "</td>")
              .append('<td class="td-footer text-center">' + formatNumber(totH34) + "</td>")
              .append('<td class="td-footer text-center" style="color: #C00000 !important;">' + formatNumber(totHO4) + "</td>")
              .append('<td class="td-footer text-center">' + formatNumber(totHT) + "</td>")
              .append('<td class="td-footer text-center" style="color:#0033CC !important;">' + renderScore(totHS) + "</td>")
              .append('<td class="td-footer text-center">' + formatNumber(totL5) + "</td>")
              .append('<td class="td-footer text-center">' + formatNumber(totL56) + "</td>")
              .append('<td class="td-footer text-center" style="color: #C00000 !important;">' + formatNumber(totLO6) + "</td>")
              .append('<td class="td-footer text-center">' + formatNumber(totLT) + "</td>")
              .append('<td class="td-footer text-center" style="color:#0033CC !important;">' + renderScore(totLS) + "</td>")
              .append('<td class="td-footer text-center">' + formatNumber(totTotal) + "</td>") 
              .append('<td class="td-footer text-center" style="color:#0033CC !important;">' + formatNumber(finalScore) + "</td>");
          },
        },
        footerCallback: function () {
          var api = this.api();
          var json = api.ajax.json();
          if (!json || !json.groupSummary) {
            // clear footer เมื่อไม่มีข้อมูล
            for (var i = 4; i <= 15; i++) {
              $(api.column(i).footer()).html("");
            }
            return;
          }
          var s = json.groupSummary;
          $(api.column(4).footer()).html(formatNumber(s.tot_High_3Month));
          $(api.column(5).footer()).html(formatNumber(s.tot_High_3_4Month));
          $(api.column(6).footer()).html(formatNumber(s.tot_High_Over4Month));
          $(api.column(7).footer()).html(formatNumber(s.tot_High_Total));
          $(api.column(8).footer()).html("");
          $(api.column(9).footer()).html(formatNumber(s.tot_Low_5Month));
          $(api.column(10).footer()).html(formatNumber(s.tot_Low_5_6Month));
          $(api.column(11).footer()).html(formatNumber(s.tot_Low_Over6Month));
          $(api.column(12).footer()).html(formatNumber(s.tot_Low_Total));
          $(api.column(13).footer()).html("");
          $(api.column(14).footer()).html(formatNumber(s.tot_Total));
          $(api.column(15).footer()).html("");
        },
      });

      // Sync top scrollbar with DataTables scrollBody
      self.$nextTick(function () {
        var scrollBody = $(self.$refs.kegRotationTable).closest('.dataTables_scrollBody');
        var topWrapper = self.$refs.topScrollWrapper;
        var topContent = self.$refs.topScrollContent;
        if (!scrollBody.length || !topWrapper || !topContent) return;

        function syncTopScrollWidth() {
          var bodyTable = scrollBody.find('table');
          var headTable = scrollBody.prev('.dataTables_scrollHead').find('table');
          var w = 0;
          if (bodyTable.length) w = Math.max(w, bodyTable[0].scrollWidth);
          if (headTable.length) w = Math.max(w, headTable[0].scrollWidth);
          topContent.style.width = w + 'px';
        }
        syncTopScrollWidth();

        var syncing = false;
        $(topWrapper).on('scroll', function () {
          if (syncing) return;
          syncing = true;
          scrollBody[0].scrollLeft = topWrapper.scrollLeft;
          syncing = false;
        });
        scrollBody.on('scroll', function () {
          if (syncing) return;
          syncing = true;
          topWrapper.scrollLeft = scrollBody[0].scrollLeft;
          syncing = false;
        });

        $(self.$refs.kegRotationTable).on('draw.dt', function () {
          self.$nextTick(function () { syncTopScrollWidth(); });
        });
      });
    },

    exportCompareReport: function (e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportCompareSnapshotVsBarcodeReport",
        responseType: "arraybuffer",
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(function() {
          var rangeMap = {
            "ไม่เกิน 3 เดือน": { from: 1,   to: 90  },
            "ไม่เกิน 4 เดือน": { from: 91,  to: 120 },
            "เกิน 4 เดือน":    { from: 121, to: null },
            "ไม่เกิน 5 เดือน": { from: 1,   to: 150 },
            "ไม่เกิน 6 เดือน": { from: 151, to: 180 },
            "เกิน 6 เดือน":    { from: 181, to: null },
          };
          var froms = [], tos = [], hasOpenEnd = false;
          self.retentionPeriod.forEach(function(r) {
            var rng = rangeMap[r];
            if (!rng) return;
            froms.push(rng.from);
            if (rng.to !== null) { tos.push(rng.to); } else { hasOpenEnd = true; }
          });
          var overDueFrom = froms.length ? Math.min.apply(null, froms) : null;
          var overDueTo   = hasOpenEnd ? null : (tos.length ? Math.max.apply(null, tos) : null);
          return {
            IsInitial: false,
            AgentCodes: self.agentCode,
            HeadAgentCodes: self.headAgentCode,
            AssetCodes: self.materialCode,
            ProductTypeIds: self.productType,
            BarcodeStatusCodes: self.barcodeStatusCode,
            FinishedProductCodes: self.productBrand,
            BrandIds: self.brand,
            CurrentLocationType: self.ownerType,
            OverDueFrom: overDueFrom,
            OverDueTo: overDueTo,
            FinalScore: self.score.length === 1 ? String(self.score[0]) : "0",
            Month: self.monthYear ? self.monthYear.month() + 1 : null,
            Year: self.monthYear ? self.monthYear.year() : null,
          };
        }()),
      })
        .then(function (response) {
          KTApp.unblockPage();
          var blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download =
            moment().format("YYYY-MM-DD") +
            "_รายงานคะแนนถังคงค้าง(ตรวจสอบข้อมูล).xlsx";
          link.click();
        })
        .catch(function () {
          KTApp.unblockPage();
        });
    },

    exportMachineScore: function (e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportMachineScore",
        responseType: "arraybuffer",
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(function() {
          var rangeMap = {
            "ไม่เกิน 3 เดือน": { from: 1,   to: 90  },
            "ไม่เกิน 4 เดือน": { from: 91,  to: 120 },
            "เกิน 4 เดือน":    { from: 121, to: null },
            "ไม่เกิน 5 เดือน": { from: 1,   to: 150 },
            "ไม่เกิน 6 เดือน": { from: 151, to: 180 },
            "เกิน 6 เดือน":    { from: 181, to: null },
          };
          var froms = [], tos = [], hasOpenEnd = false;
          self.retentionPeriod.forEach(function(r) {
            var rng = rangeMap[r];
            if (!rng) return;
            froms.push(rng.from);
            if (rng.to !== null) { tos.push(rng.to); } else { hasOpenEnd = true; }
          });
          var overDueFrom = froms.length ? Math.min.apply(null, froms) : null;
          var overDueTo   = hasOpenEnd ? null : (tos.length ? Math.max.apply(null, tos) : null);
          return {
            IsInitial: false,
            AgentCodes: self.agentCode,
            HeadAgentCodes: self.headAgentCode,
            AssetCodes: self.materialCode,
            ProductTypeIds: self.productType,
            BarcodeStatusCodes: self.barcodeStatusCode,
            FinishedProductCodes: self.productBrand,
            BrandIds: self.brand,
            CurrentLocationType: self.ownerType,
            OverDueFrom: overDueFrom,
            OverDueTo: overDueTo,
            FinalScore: self.score.length === 1 ? String(self.score[0]) : "0",
            Month: self.monthYear ? self.monthYear.month() + 1 : null,
            Year: self.monthYear ? self.monthYear.year() : null,
          };
        }()),
      })
        .then(function (response) {
          KTApp.unblockPage();
          var blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // link.download =
          //   "รายงานคะแนนถังคงค้าง(ผู้ดูแลระบบ)_" +
          //   moment().format("DDMMYYYY") +
          //   ".xlsx";

             link.download =
             moment().format("YYYY-MM-DD") +"_รายงานคะแนนถังคงค้าง"+
            ".xlsx";
          link.click();
        })
        .catch(function () {
          KTApp.unblockPage();
        });
    },

    formReset: function () {
      this.productType = [];
      this.barcodeStatusCode = [];
      this.agentCode = [];
      this.materialCode = [];
      this.retentionPeriod = [];
      this.headAgentCode = [];
      this.productBrand = [];
      this.score = [];
      this.ownerType = [];
      this.brand = [];

      // Reset month/year to current
      this.monthYear = moment();
      $(this.$refs.monthYearPicker).datepicker("update", this.monthYear.format("MM/YYYY"));
      this.dataAsOfLabel = '';

      if (this.dataTable) {
        this.dataTable.ajax.reload();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/Report/KegRotationScore.vue